import React, { useEffect, useState, useRef, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import TopBar from "../../components/TopBar";
import { serverDomain } from "../../config";
import SideBar from "../../components/SideBar";
import { FaArrowUp, FaArrowDown } from 'react-icons/fa';  // Для стрелочек



const ConversionsPage = () => {
    const today = new Date();
    const lastWeek = new Date();
    lastWeek.setDate(today.getDate() - 7);

    const formatDateMSK = (date) => {
        const mskOffset = 3 * 60 * 60 * 1000; // Смещение на 3 часа
        return new Date(date.getTime() + mskOffset).toISOString().split('T')[0];
    };  
    const [searchUserId, setSearchUserId] = useState("");
    const [transactions, setTransactions] = useState([]);
    const [startDate, setStartDate] = useState(formatDateMSK(lastWeek));
    const [endDate, setEndDate] = useState(formatDateMSK(today));
    const [sortColumn, setSortColumn] = useState("transaction_date");
    const [sortOrder, setSortOrder] = useState("desc");
    const navigate = useNavigate();
    const [selectedStreams, setSelectedStreams] = useState([]);
    const [selectedOffers, setSelectedOffers] = useState([]);
    const [allStreams, setAllStreams] = useState([]); // Все потоки
    const [allOffers, setAllOffers] = useState([]); // Все офферы
    const [selectedLandings, setSelectedLandings] = useState([]);
    const [showAdditionalFilters, setShowAdditionalFilters] = useState(false);
    const [loading, setLoading] = useState(false);
    const [hideUnsuccessful, setHideUnsuccessful] = useState(false);
    const reqIdRef = useRef(0);

    const [page, setPage] = useState(1);
    const [pageInput, setPageInput] = useState("1");
    const limit = 20;

    const [showErrorsLegend, setShowErrorsLegend] = useState(false);
    const legendWrapRef = useRef(null);

    useEffect(() => {
    const onDocClick = (e) => {
        if (!legendWrapRef.current) return;
        if (!legendWrapRef.current.contains(e.target)) setShowErrorsLegend(false);
    };
    const onEsc = (e) => { if (e.key === "Escape") setShowErrorsLegend(false); };

    document.addEventListener("mousedown", onDocClick);
    document.addEventListener("keydown", onEsc);
    return () => {
        document.removeEventListener("mousedown", onDocClick);
        document.removeEventListener("keydown", onEsc);
    };
    }, []);


    const toggleHideUnsuccessful = () => {
        setHideUnsuccessful(prev => !prev);
      };
      

    const handleUpdate = () => {
        setLoading(true);
        setTimeout(() => {
            fetchTransactions();
            setLoading(false);
        }, 1000);
    };


    const fetchTransactions = useCallback(async () => {
        const myId = ++reqIdRef.current;
        setLoading(true);
        try {
          const token = localStorage.getItem("token");
          const url =
            `${serverDomain}/api/conversions/transactions` +
            `?start_date=${startDate}&end_date=${endDate}` +
            `&streams=${selectedStreams.join(',')}` +
            `&offers=${selectedOffers.join(',')}` +
            `&hideUnsuccessful=${hideUnsuccessful}` +
            `&page=${page}&limit=${limit}` +
            (searchUserId ? `&userIdSearch=${encodeURIComponent(searchUserId)}` : "");

      
          const res = await fetch(url, {
            method: "GET",
            headers: { "Authorization": `Bearer ${token}` }
          });
      
          const data = await res.json();
          if (reqIdRef.current === myId) {
            setTransactions(data.transactions || []);
          }
        } catch (e) {
          if (reqIdRef.current === myId) {
            console.error("Ошибка загрузки данных:", e);
          }
        } finally {
          if (reqIdRef.current === myId) {
            setLoading(false);
          }
        }
      }, [startDate, endDate, selectedStreams, selectedOffers, hideUnsuccessful, page, limit, searchUserId]);
      



    const fetchFilters = async () => {
        try {
            const token = localStorage.getItem("token");

            const response = await fetch(
                `${serverDomain}/api/conversions/filters`,
                {
                    method: "GET",
                    headers: {
                        "Authorization": `Bearer ${token}`
                    }
                }
            );

            const data = await response.json();
            setAllStreams(data.streams);
            setAllOffers(data.offers);
        } catch (error) {
            console.error("Ошибка загрузки фильтров:", error);
        }
    };


    useEffect(() => {
        fetchFilters();
        setStartDate(formatDateMSK(lastWeek));
        setEndDate(formatDateMSK(today));
    }, []);

    useEffect(() => {
        fetchTransactions();
      }, [fetchTransactions]);
      

    useEffect(() => {
        fetchTransactions();
    }, [startDate, endDate, selectedStreams, selectedOffers, selectedLandings, page, hideUnsuccessful]);



    const handleSort = (column) => {
        const newSortOrder = sortColumn === column && sortOrder === "asc" ? "desc" : "asc";
        setSortColumn(column);
        setSortOrder(newSortOrder);

        const sortedData = [...transactions].sort((a, b) => {
            let valueA = a[column];
            let valueB = b[column];

            if (column === "transaction_date") {
                valueA = new Date(valueA);
                valueB = new Date(valueB);
                return newSortOrder === "asc" ? valueA - valueB : valueB - valueA;
            } else if (column === "transaction_amount") {
                valueA = parseFloat(valueA);
                valueB = parseFloat(valueB);
                return newSortOrder === "asc" ? valueA - valueB : valueB - valueA;
            } else if (typeof valueA === "string" && typeof valueB === "string") {
                return newSortOrder === "asc" ? valueA.localeCompare(valueB) : valueB.localeCompare(valueA);
            }

            return 0;
        });

        setTransactions(sortedData);
    };

    const renderSortIcon = (column) => {
        if (column === sortColumn) {
            return sortOrder === "asc" ? <FaArrowUp/> : <FaArrowDown />;
        }
        return null;
    };

    // Обработчик выбора потоков
    const toggleStreamSelection = (stream) => {
        setSelectedStreams(prevSelected => {
            if (prevSelected.includes(stream)) {
                return prevSelected.filter(s => s !== stream);
            }
            return [...prevSelected, stream];
        });
    };

    // Обработчик выбора офферов
    const toggleOfferSelection = (offer) => {
        setSelectedOffers(prevSelected => {
            if (prevSelected.includes(offer)) {
                return prevSelected.filter(o => o !== offer);
            }
            return [...prevSelected, offer];
        });
    };

    const handlePrevPage = () => {
        setPage(prev => {
            const newPage = Math.max(prev - 1, 1);
            setPageInput(newPage.toString());
            return newPage;
        });
    };

    const handleNextPage = () => {
        setPage(prev => {
            const newPage = prev + 1;
            setPageInput(newPage.toString());
            return newPage;
        });
    };

    // Обработчик изменения input
    const handlePageInputChange = (e) => {
        const value = e.target.value;
        setPageInput(value);
        const newPage = Number(value);
        if (!isNaN(newPage) && newPage > 0) {
            setPage(newPage);
        }
    };

    // При потере фокуса, если поле пустое, сбрасываем в 1
    const handlePageInputBlur = () => {
        if (pageInput === "") {
            setPage(1);
            setPageInput("1");
        }
    };

    const processTransaction = (transaction) => {
        if (transaction.offer_name === "Fast Love CPA (покупка)") {
            if (transaction.transaction_type === "purchase") {
                transaction.transaction_amount = 700;
            } else {
                transaction.transaction_amount = 0;
            }
        }
        return transaction;
    };

    useEffect(() => {
        setPage(1);
        setPageInput("1");
      }, [searchUserId]);
      

    return (
        <div>
            <TopBar pageTitle={"Конверсии"}/>

            <div className="main-container">
                <SideBar />
                <main className="home-main flex-grow-1">
                    <div className="fl-page">
                    <div className="fl-subtabs">
                        <button className="fl-subtabs__btn" onClick={() => navigate("/statistics")}>Статистика</button>
                        <button className="fl-subtabs__btn is-active">Конверсии</button>
                        </div>

                        <div className="fl-toolbar">
                        <input className="fl-input" type="date" value={startDate} onChange={(e) => setStartDate(e.target.value)} />
                        <span className="fl-toolbar__dash">-</span>
                        <input className="fl-input" type="date" value={endDate} onChange={(e) => setEndDate(e.target.value)} />

                        <button
                            className="fl-btn fl-btn--ghost fl-toolbar-action fl-toolbar-action--dots"
                            onClick={() => setShowAdditionalFilters(!showAdditionalFilters)}
                            type="button"
                            title="Фильтры"
                        >
                            …
                        </button>

                        <button
                            className="fl-btn fl-toolbar-action fl-toolbar-action--toggle"
                            onClick={toggleHideUnsuccessful}
                            disabled={loading}
                        >
                            {hideUnsuccessful ? "Показать все" : "Скрыть неуспешные"}
                        </button>

                        <button
                            className="fl-btn fl-toolbar-action fl-toolbar-action--update"
                            onClick={handleUpdate}
                            disabled={loading}
                        >
                            Обновить
                        </button>

                        <div
                            ref={legendWrapRef}
                            className="fl-popwrap fl-toolbar-action fl-toolbar-action--info"
                        >
                        <button
                            className="fl-icon-circle"
                            type="button"
                            onClick={() => setShowErrorsLegend(v => !v)}
                            title="Коды ошибок"
                        >
                            i
                        </button>

                            {showErrorsLegend && (
                            <div className="fl-popover" role="dialog" aria-label="Справка по кодам ошибок">
                                <div className="fl-popover__head">
                                <div className="fl-popover__title">Наиболее частые коды ошибок</div>
                                <button className="fl-popover__close" onClick={() => setShowErrorsLegend(false)} aria-label="Закрыть">×</button>
                                </div>

                                <ul style={{ margin: 0, paddingLeft: 16, fontSize: 12, lineHeight: 1.6, color: "var(--fl-text)" }}>
                                <li><b>5004</b> — Карта потеряна.</li>
                                <li><b>5005</b> — Отказ эмитента без объяснения причин.</li>
                                <li><b>5014</b> — Некорректный номер карты.</li>
                                <li><b>5043</b> — Карта украдена.</li>
                                <li><b>5051</b> — Недостаточно средств.</li>
                                <li><b>5054</b> — Карта просрочена или неверный код.</li>
                                <li><b>5059</b> — Подозрение в мошенничестве.</li>
                                <li><b>5061</b> — Превышена сумма по карте.</li>
                                <li><b>5062</b> — Запрещены автоплатежи.</li>
                                <li><b>5065</b> — Превышен лимит трат по карте.</li>
                                <li><b>5204</b> — Операция недоступна сейчас.</li>
                                </ul>
                            </div>
                            )}
                        </div>
                    </div>

                        {showAdditionalFilters && (
                        <div className="fl-morefilters">
                            <div className="fl-morefilters__grid">
                            <div className="fl-field">
                                <div className="fl-label">Потоки</div>
                                <select multiple value={selectedStreams} onChange={() => {}} style={{ height: 120, borderRadius: 16, border: "1px solid var(--fl-border)", padding: 8 }}>
                                {allStreams.map((stream) => (
                                    <option key={stream} value={stream} onClick={() => toggleStreamSelection(stream)}>
                                    {stream}
                                    </option>
                                ))}
                                </select>

                                <div style={{height:8}} />

                                <div className="fl-label">User ID</div>
                                <input className="fl-input fl-input--wide" type="text" value={searchUserId} onChange={(e) => setSearchUserId(e.target.value)} placeholder="Поиск по User ID" />
                            </div>

                            <div className="fl-field">
                                <div className="fl-label">Офферы</div>
                                    <select multiple value={selectedOffers} onChange={() => {}} style={{ height: 120, borderRadius: 16, border: "1px solid var(--fl-border)", padding: 8 }}>
                                    {allOffers.map((offer) => (
                                        <option key={offer.id} value={offer.id} onClick={() => toggleOfferSelection(offer.id)}>
                                        {offer.name}
                                        </option>
                                    ))}
                                    </select>
                                </div>
                            </div>
                        </div>
                        )}

                        {loading ? (
                            <div className="loading-container">
                                <div className="loader"></div>
                            </div>
                        ) : transactions.length > 0 ? (
                            <div className="fl-table-wrap fl-table-wrap--conversions">
                                <table className="fl-table fl-table--conversions">
                                    <thead>
                                    <tr>
                                        <th className="fl-col-date" onClick={() => handleSort("transaction_date")}>
                                        <span>Дата {renderSortIcon("transaction_date")}</span>
                                        </th>
                                        <th className="fl-col-offer">Оффер</th>
                                        <th className="fl-col-stream" onClick={() => handleSort("stream")}>
                                        <span>Поток {renderSortIcon("stream")}</span>
                                        </th>
                                        <th className="fl-col-status">Статус</th>
                                        <th className="fl-col-income" onClick={() => handleSort("transaction_amount")}>
                                        <span>Доход {renderSortIcon("transaction_amount")}</span>
                                        </th>
                                        <th className="fl-col-user">User ID</th>
                                        <th className="fl-col-goal">Цель</th>
                                        <th className="fl-col-state">Состояние</th>
                                    </tr>
                                    </thead>

                                    <tbody>
                                    {transactions.map(transaction => {
                                        const processedTransaction = processTransaction(transaction);
                                        return (
                                        <tr key={`${transaction.status}_${transaction.transaction_id}`}>
                                            <td className="fl-col-date">{new Date(processedTransaction.transaction_date).toLocaleString()}</td>
                                            <td className="fl-col-offer">{processedTransaction.offer_name}</td>
                                            <td className="fl-col-stream">{processedTransaction.stream}</td>
                                            <td className="fl-col-status">{processedTransaction.status}</td>
                                            <td className="fl-col-income">{processedTransaction.transaction_amount}</td>
                                            <td className="fl-col-user">{processedTransaction.user_id}</td>
                                            <td className="fl-col-goal">
                                            {(processedTransaction.transaction_type === "stars_purchase" || processedTransaction.transaction_type === "likes_pack_purchase")
                                                ? "Покупка звезд"
                                                : processedTransaction.transaction_type === "purchase"
                                                ? "Покупка"
                                                : processedTransaction.transaction_type === "auto_debit"
                                                ? "Автосписание"
                                                : processedTransaction.transaction_type}
                                            </td>
                                            <td className="fl-col-state">
                                            {processedTransaction.status === "Успешно" ? "Успешно" : "Неудачно"}
                                            </td>
                                        </tr>
                                        );
                                    })}
                                    </tbody>
                                </table>  
                            <div className="fl-pagination">
                                <button className="fl-btn" onClick={handlePrevPage} disabled={page === 1}>Предыдущая</button>
                                    <span className="fl-pagination__label">Страница</span>
                                    <input className="fl-input fl-input--page" type="number" value={pageInput} onChange={handlePageInputChange} onBlur={handlePageInputBlur} />
                                <button className="fl-btn" onClick={handleNextPage}>Следующая</button>
                            </div>
                        </div>
                        ) : (
                            <div className="loading-container">
                                <div className="loader"></div>
                            </div>
                        )}


                    </div>
                </main>
            </div>
        </div>
    );
};

export default ConversionsPage;
